import { defineStore } from 'pinia'
import { routing } from '@/Support/Routing/Functions/routing'
import {
  NotificationBannerData,
  NotificationCategory,
  NotificationData,
  NotificationsData,
  SimpleNotificationData,
} from '@/Support/Communications/Interfaces/NotificationData'
import { RoutingParams } from '@/Support/Routing/Interfaces/routing'
import { FleetingLabelDuration } from '@/Support/Global/Interfaces/FleetingLabelDuration'

interface State {
  notificationsData: NotificationsData | null
  notificationData: NotificationData | SimpleNotificationData | null
  notificationBannerData: NotificationBannerData
  showNotification: boolean
  showMiniNotification: boolean
  loadingNotifications: boolean
  miniNotificationTitle: string
  miniNotificationDescription: string | null | undefined
  miniNotificationButtonLabel: string | undefined
  miniNotificationDuration: FleetingLabelDuration | undefined
  miniNotificationFleeting: boolean | undefined
}

export interface MiniNotificationData {
  title: string
  description?: string
  buttonLabel?: string
  duration?: FleetingLabelDuration
  fleeting?: boolean
}

export const useNotifications = defineStore('notifications', {
  state: (): State => {
    return {
      notificationsData: null,
      notificationData: null,
      notificationBannerData: {
        buttonTitle: 'See',
      },
      showNotification: false,
      loadingNotifications: false,
      showMiniNotification: false,
      miniNotificationTitle: '',
      miniNotificationDescription: null,
      miniNotificationDuration: FleetingLabelDuration.Normal,
      miniNotificationButtonLabel: undefined,
      miniNotificationFleeting: false,
    }
  },
  actions: {
    async loadNotifications(params?: RoutingParams) {
      this.loadingNotifications = true
      const response = await window.axios.get(
        routing('communications.notifications.index', {
          ...params,
          no_filament: true,
        }),
      )
      this.notificationsData = response.data as NotificationsData
      this.loadingNotifications = false
    },

    newNotification(data: NotificationData | SimpleNotificationData) {
      this.notificationData = data
      this.showNotification = true
    },

    errorNotification(title: string, content: string) {
      this.newNotification({
        title,
        content,
        category: NotificationCategory.Danger,
        system: true,
      })
    },

    newMiniNotification({
      title,
      description,
      buttonLabel,
      duration,
      fleeting,
    }: MiniNotificationData) {
      this.showMiniNotification = true
      this.miniNotificationTitle = title
      this.miniNotificationDescription = description
      this.miniNotificationButtonLabel = buttonLabel
      this.miniNotificationDuration = duration
      this.miniNotificationFleeting = fleeting
    },
  },
})
